import './bootstrap';
import 'flowbite';
import { createApp } from 'vue';

import App from './App.vue'
import router from './router.js'
import store from './store';
import { pwaStore } from './pwa/PwaStore.js';
import { registerServiceWorker } from './pwa/registerSW.js';

// Axios Interceptor for 401 Handling - Critical Security Fix
// This ensures that any 401 response from the server clears all auth data
// and redirects to login, preventing authentication bypass via localStorage manipulation
axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            const isLoginRequest = error.config?.url?.includes('/login');

            if (!isLoginRequest) {
                localStorage.removeItem('vuex')
                localStorage.removeItem('id')
                localStorage.removeItem('role')
                localStorage.removeItem('user')

                axios.defaults.headers.common['Authorization'] = ''

                store.commit('removeToken')

                window.location.href = '/'
            }
        }
        return Promise.reject(error)
    }
)

window.addEventListener('online', () => { pwaStore.isOnline = true })
window.addEventListener('offline', () => { pwaStore.isOnline = false })

createApp(App)
    .use(router)
    .use(store)
    .mount("#app")

registerServiceWorker()